"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.defaultProps = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Icon component
 *
 * @param {Object} props
 * @param {boolean} [props.inline] - Deprecated. Use `props.size` instead.
 * @param {...*} [otherProps] - Additional arguments to the icon component.
 */
var Icon = function Icon(_ref) {
  var className = _ref.className,
      children = _ref.children,
      id = _ref.id,
      isDecorative = _ref.isDecorative,
      title = _ref.title,
      size = _ref.size,
      otherProps = _objectWithoutProperties(_ref, ["className", "children", "id", "isDecorative", "title", "size"]);

  var classnames = className && className.split(" ") || []; // Base icon class

  classnames.push("DhigSvgIcon"); // Add classes related to display icons

  if (id.includes("display-icon")) {
    classnames.push("DhigSvgIcon--type--display-icon"); // Force display icons to be large or medium

    size = size === _constants.sizes.LARGE ? _constants.sizes.LARGE : _constants.sizes.MEDIUM;
  } // Add classes related to ui controls


  if (id.includes("ui-controls")) {
    classnames.push("DhigSvgIcon--type--ui-control-icon"); // Force ui controls to be small

    size = _constants.sizes.SMALL;
  } // Add size class


  classnames.push("DhigSvgIcon--size--".concat(size));
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    "aria-hidden": isDecorative,
    className: classnames.join(" ")
  }, otherProps), children || /*#__PURE__*/_react.default.createElement("use", {
    xlinkHref: "#".concat(id),
    className: id
  }), title && /*#__PURE__*/_react.default.createElement("title", null, title));
};

Icon.propTypes = {
  /**
   * React icons content
   */
  children: _propTypes.default.node,

  /**
   * Class names to apply to the icon component
   */
  className: _propTypes.default.string,

  /**
   * Id of the icon in the sprite
   */
  id: _propTypes.default.string.isRequired,

  /**
   * Whether or not the button should appear hidden to screen readers
   */
  isDecorative: _propTypes.default.bool,

  /**
   * Icon size
   */
  size: _propTypes.default.oneOf(_constants.availableSizes),

  /**
   * Accessible title
   */
  title: _propTypes.default.string
};
var defaultProps = {
  isDecorative: false,
  size: _constants.sizes.INHERIT,
  id: ""
};
exports.defaultProps = defaultProps;
Icon.defaultProps = _objectSpread({}, defaultProps);
Icon.__docgenInfo = {
  "description": "Icon component\n\n@param {Object} props\n@param {boolean} [props.inline] - Deprecated. Use `props.size` instead.\n@param {...*} [otherProps] - Additional arguments to the icon component.",
  "methods": [],
  "displayName": "Icon",
  "props": {
    "isDecorative": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether or not the button should appear hidden to screen readers"
    },
    "size": {
      "defaultValue": {
        "value": "sizes.INHERIT",
        "computed": true
      },
      "type": {
        "name": "enum",
        "computed": true,
        "value": "availableSizes"
      },
      "required": false,
      "description": "Icon size"
    },
    "id": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Id of the icon in the sprite"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "React icons content"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Class names to apply to the icon component"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Accessible title"
    }
  }
};
var _default = Icon;
exports.default = _default;